import React from 'react'
import { ClickAwayListener, Popper } from '@mui/material'
import { More } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

type TableHeaderFilterComponentProps = {
  hovering?: boolean
  children: React.FC<{ closeModal: () => void }>
}

const TableHeaderFilterComponent: React.FC<TableHeaderFilterComponentProps> = ({
  hovering,
  children: Children
}) => {
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = React.useState<null | Element>(null)
  const open = React.useMemo(() => Boolean(anchorEl), [anchorEl])
  const mainRef = React.useRef()

  const classes = useStyles()

  const handleClick = React.useCallback((e: React.MouseEvent) => {
    setAnchorEl(e.currentTarget)
  }, [])

  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  if (!hovering && !open) {
    return null
  }

  return (
    <div onClick={e => e.stopPropagation()} className={classes.root}>
      <More
        onClick={handleClick}
        size={theme.size.sm}
        className={classes.icon}
      />

      <ClickAwayListener onClickAway={handleClose}>
        <div ref={mainRef} onClick={handleClick}>
          <Popper open={open} anchorEl={anchorEl} style={{ zIndex: '1500' }}>
            <div className={classes.menu}>
              <Children closeModal={handleClose} />
            </div>
          </Popper>
        </div>
      </ClickAwayListener>
    </div>
  )
}

export default TableHeaderFilterComponent
